<template>
    <Bar id="bar-chart" :options="chartOptions" :data="chartData" :key="render"/>
</template>

<script>
import 'chart.js/auto';
import { Bar } from 'vue-chartjs';

import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ChartDataLabels)
import { throttle } from 'throttle-debounce';
export default {
    name: 'BarChart',
    components: { Bar },
    props: ['dataProps'],
    data() {
        return {
            chartData: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: '#A3D562',
                    datalabels: {
                        anchor: 'end',
                        align: 'top',
                        formatter: (val) => {
                            return `${this.convertGektars(val)} га`
                        },
                        font: {
                            family: 'Gilroy-semibold',
                            size: 14,
                            color: '#737373'
                        },
                    },
                    base: 1000000,
                    tooltips: {
                        enabled: false
                    },
                    animation: {
                    duration: 0,
                },

                }]
            },
            chartOptions: {

                skipNull: true,
                scales: {
                    yAxis: {
                        display: false,
                        grid: {
                            display: false
                        },
                    },
                    xAxis: {
                        grid: {
                            display: false,
                            borderColor: '#252628',
                            borderWidth: 1,

                        },

                        ticks: {
                            color: '#252628',
                            font: {
                                size: 14,
                                family: 'Gilroy-medium',
                                weight: 500
                            }
                        },
                    },
                },
                hover: {
                    mode: null
                },
                //categoryPercentage: 0.7,
                barPercentage: 0.75,
                responsive: true,
                maintainAspectRatio: false,
                aspectRatio: 500/768,
                plugins: {
                    tooltip: {
                        enabled: false
                    },
                    legend: {
                        display: false
                    },
                    tooltips: {
                        display: false
                    },
                },
            },
            chartPlugins: [ChartDataLabels],
            render: null,
        }
    },
    watch: {
        dataProps(new_data, old_data) {
            if (old_data === undefined && new_data !== undefined) {
                this.chartData.labels = [...this.dataProps.map((el) => el.short)];
                this.chartData.datasets[0].data = [...this.dataProps.map((el) => el.area)];
                this.render++;
            }
        },
    },
    mounted() {
        this.setWindowWidth();
        window.addEventListener('resize', throttle(1000, this.setWindowWidth));
    },
    methods: {
        convertGektars(val) {
            return new Intl.NumberFormat("ru").format(Math.round(val * 0.0001))
        },
        setWindowWidth() {
            this.windowWidth = document.documentElement.clientWidth;
            if (this.windowWidth < 768) {
                this.chartOptions.responsive = false;
                this.chartOptions.aspectRatio = 1.9;

            } else if (this.windowWidth >= 768) {
                this.chartOptions.responsive = true;
                this.chartOptions.aspectRatio = 1.5;
            }
            this.render++;
        },
    }
}
</script>